import { render, staticRenderFns } from "./SuspiciousTransactionReport.vue?vue&type=template&id=7957da94&scoped=true&"
import script from "./SuspiciousTransactionReport.vue?vue&type=script&lang=js&"
export * from "./SuspiciousTransactionReport.vue?vue&type=script&lang=js&"
import style0 from "./SuspiciousTransactionReport.vue?vue&type=style&index=0&id=7957da94&lang=scss&scoped=true&"
import style1 from "./SuspiciousTransactionReport.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7957da94",
  null
  
)

export default component.exports